'use client'
import { Newspaper, Sparkles } from 'lucide-react'
import { useTranslations } from 'next-intl'

export default function NoArticles() {
  const t = useTranslations('Blog')

  return (
    <div className="flex flex-col items-center justify-center text-center py-20 px-6 min-h-[40vh]">
      <div className="relative mb-8">
        <div className="absolute inset-0 rounded-full bg-[#A7D3AF]/50 blur-3xl scale-150" aria-hidden="true" />
        <div className="relative p-7 rounded-full bg-white border-2 border-dashed border-[#059669] animate-float">
          <Newspaper size={44} className="text-[#008D63]" />
        </div>
        <Sparkles size={18} className="absolute -top-1 -right-2 text-[#FBB41E] animate-float" style={{ animationDelay: '0.5s' }} />
        <Sparkles size={14} className="absolute bottom-1 -left-3 text-[#008D63] animate-float" style={{ animationDelay: '1.2s' }} />
      </div>

      <h2 className="text-[#064E3B] text-2xl md:text-3xl font-bold mb-3">{t('empty_title')}</h2>
      <p className="text-[#064E3B]/70 text-lg max-w-sm">{t('empty_text')}</p>
    </div>
  )
}
